var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockedDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3677_22390)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 21,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 15,
    fill: "#ADAEB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.3794 25.2251C26.2282 25.079 26.0257 24.9982 25.8154 25C25.6052 25.0019 25.404 25.0862 25.2554 25.2349C25.1067 25.3836 25.0224 25.5847 25.0205 25.795C25.0187 26.0052 25.0995 26.2078 25.2456 26.359L29.8764 30.9901L25.2448 35.6213C25.1682 35.6952 25.1071 35.7837 25.0651 35.8816C25.0231 35.9794 25.001 36.0846 25 36.1911C24.9991 36.2976 25.0194 36.4032 25.0597 36.5017C25.1 36.6003 25.1596 36.6898 25.2349 36.7651C25.3102 36.8404 25.3997 36.9 25.4982 36.9403C25.5968 36.9806 25.7024 37.0009 25.8088 37C25.9153 36.999 26.0205 36.9769 26.1184 36.9349C26.2162 36.8929 26.3047 36.8318 26.3786 36.7552L31.0103 32.1241L35.6411 36.7552C35.7923 36.9013 35.9948 36.9821 36.2051 36.9803C36.4153 36.9784 36.6165 36.8941 36.7651 36.7454C36.9138 36.5967 36.9981 36.3956 37 36.1853C37.0018 35.9751 36.921 35.7725 36.7749 35.6213L32.1441 30.9901L36.7749 26.359C36.921 26.2078 37.0018 26.0052 37 25.795C36.9981 25.5847 36.9138 25.3836 36.7651 25.2349C36.6165 25.0862 36.4153 25.0019 36.2051 25C35.9948 24.9982 35.7923 25.079 35.6411 25.2251L31.0103 29.8562L26.3794 25.2243V25.2251Z",
    fill: "#666666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3677_22390",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3677_22390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3677_22390",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedDesk);
export default __webpack_public_path__ + "static/media/blocked-desk.da7f3d596bccd8ce9071f504c49a8652.svg";
export { ForwardRef as ReactComponent };